import {Button, Dropdown, DropdownItem, Tooltip} from 'platform/components';
import {HStack, ThemeIconKey} from 'platform/foundation';

import {useSourcingAllowedCountryAndCurrencyQuery} from '@dms/api/core';
import {useSetUserSettingsItemMutation} from '@dms/api/customer';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {handleApiError} from '@dms/shared';

import {useBoolean} from 'shared/web';

import {useSourcingCurrency} from '../../../hooks/useSourcingCurrency';
import {useSourcingTargetCountry} from '../../../hooks/useSourcingTargetCountry';

export function HeaderSettings() {
  const [updateUserSettings] = useSetUserSettingsItemMutation();
  const [isCountryDropdownOpen, countryDropDownOpen, countryDropDownClose] = useBoolean();
  const [isCurrencyDropdownOpen, currencyDropDownOpen, currencyDropDownClose] = useBoolean();

  const {data} = useSourcingAllowedCountryAndCurrencyQuery();

  const country = useSourcingTargetCountry();
  const currency = useSourcingCurrency();

  const onChangeCountry = (value: string) => {
    updateUserSettings({
      settingKey: 'sourcing_buyer_country',
      userSettingRequestBody: {value},
    })
      .unwrap()
      .catch(handleApiError);
  };

  const onChangeCurrency = (value: string) => {
    updateUserSettings({
      settingKey: 'sourcing_currency',
      userSettingRequestBody: {value},
    })
      .unwrap()
      .catch(handleApiError);
  };

  return (
    <HStack align="center">
      <Dropdown
        dropdownControl={
          <Tooltip label={i18n.t('entity.address.labels.targetCountry')}>
            <Button
              aria-label="topBar"
              variant="ghost"
              rightIcon={
                isCountryDropdownOpen ? 'navigation/arrow_drop_up' : 'navigation/arrow_drop_down'
              }
              leftIcon={`flags/${country?.code}` as ThemeIconKey}
              title={country?.code}
            />
          </Tooltip>
        }
        onOpen={countryDropDownOpen}
        onClose={countryDropDownClose}
        data-testid={testIds.sourcing.classifieds('headerSettings-targetCountry')}
      >
        {data?.countries?.map((country) => (
          <DropdownItem
            key={country}
            leftIcon={`flags/${country}` as ThemeIconKey}
            label={country}
            onClick={() => onChangeCountry(country)}
          />
        ))}
      </Dropdown>
      <Dropdown
        dropdownControl={
          <Tooltip label={i18n.t('entity.bank.labels.currency')}>
            <Button
              aria-label="topBar"
              variant="ghost"
              rightIcon={
                isCurrencyDropdownOpen ? 'navigation/arrow_drop_up' : 'navigation/arrow_drop_down'
              }
              title={currency?.name}
            />
          </Tooltip>
        }
        onOpen={currencyDropDownOpen}
        onClose={currencyDropDownClose}
        data-testid={testIds.sourcing.classifieds('headerSettings-currency')}
      >
        {data?.currencies?.map((currency) => (
          <DropdownItem
            key={currency}
            label={currency}
            onClick={() => onChangeCurrency(currency)}
          />
        ))}
      </Dropdown>
    </HStack>
  );
}
